import Cookie from 'cookie-universal'
import config from 'config'
import {experiment} from './contexts'

let expiration = new Date()

expiration.setMilliseconds(expiration.getMilliseconds() + 365 * 864e5)

const cookieOptions = {
    expires: expiration,
    secure: config.env === 'production',
    path: '/',
    httpOnly: false
  },
  extractChildrenText = children => {
    if (typeof children === 'string') {
      return children
    } else if (Array.isArray(children)) {
      return children.join(' ')
    }

    return ''
  },
  activateExperimentContext = () => {
    if (!global.window || !window.snowplow) {
      console.warn('Snowplow is not initialized')

      return
    }

    // If not to clear existing context the same context will be added one more time
    window.snowplow('clearGlobalContexts')

    const EXPERIMENT_PREFIX = /\bvt_/g,
      cookies = Cookie().getAll(cookieOptions),
      experiments = [],
      experimentsList =
        window.credExperiments && window.credExperiments.allExperiments || {}

    Object.entries(cookies).forEach(cookie => {
      if (cookie[0].match(EXPERIMENT_PREFIX)) {
        const experimentId = cookie[0].replace(EXPERIMENT_PREFIX, ''),
          variationId = cookie[1],
          experimentObj = experimentsList[experimentId] || {},
          variation =
            experimentObj.variations &&
            experimentObj.variations.find(
              item => parseInt(item.id) === parseInt(variationId)
            )

        window.snowplow('addGlobalContexts', [
          experiment.analytics({
            experimentId,
            experimentName: experimentObj && experimentObj.name || 'no data',
            variationId,
            variationName: variation && variation.description || 'no data'
          })
        ])
      }
    })
  },
  activateWidgetsExperimentContext = experiments => {
    const {activeExperiments, experiments: experimentConfig, variationMap} = experiments

    activeExperiments.forEach(experimentId => {
      const foundExperiment = experimentConfig.find(experiment => experiment.id === experimentId),
        {name: experimentName, variations} = foundExperiment,
        foundVariation = variations.find(variation => variation.id == variationMap[experimentId]),
        {description: variationName, id: variationId} = foundVariation

      window.snowplow('addGlobalContexts', [
        experiment.analytics({
          experimentId,
          experimentName,
          variationId: `${variationId}`,
          variationName
        })
      ])
    })
  },
  cleanUtmParameters = (location, history) => {
    if (!global.window || !location || !location.search || !history) {
      return
    }

    const utms = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_internal',
        'utm_referrer',
        'user_agent',
        'gclid',
        'kclickid',
        'msclkid',
        'loanAmount',
        'loanPurpose'
      ],
      originalSearchParams = location.search,
      searchParams = location.search
        .replace('?', '')
        .split('&')
        .filter(param => !utms.includes(param.replace(/(=.*)/, '')))
        .join('&')

    if (originalSearchParams.length !== searchParams.length) {
      const redirectUrlSearch =
        searchParams.length && `?${searchParams}` || ''

      history.replace({search: redirectUrlSearch})
    }
  }

export {activateExperimentContext, activateWidgetsExperimentContext, extractChildrenText, cleanUtmParameters}
